import { ChimeraCourseInfo } from '@/models/chimera/ChimeraCourseModel';
import { SupportMaterialFoldersInfo } from '@/models/chimera/ChimeraCourseMaterialsModel';

export interface CourseState {
  currentChimeraCourse: ChimeraCourseInfo | null;
  chimeraCourses?: ChimeraCourseInfo[] | null;
  expiredChimeraCourses?: ChimeraCourseInfo[] | null;
  chimeraCoursesMaterials: { [key: string]: SupportMaterialFoldersInfo[] };
}

const state: CourseState = {
  currentChimeraCourse: null,
  chimeraCourses: [],
  expiredChimeraCourses: [],
  chimeraCoursesMaterials: {},
};

export default state;
